module.exports = __webpack_public_path__ + "img/full1-min.205b4b94.png";